import { render } from "./updateForm.vue?vue&type=template&id=8b98a4c4&scoped=true"
import script from "./updateForm.vue?vue&type=script&lang=js"
export * from "./updateForm.vue?vue&type=script&lang=js"

import "./updateForm.vue?vue&type=style&index=0&id=8b98a4c4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b98a4c4"]])

export default __exports__